import { useAuth0 } from '@auth0/auth0-react';
import { useCallback, useEffect } from 'react';
import { useAppDispatch } from '../../../app/hooks';
import { security } from '../../../app/security';
import { setApiToken } from '../authSlice';

/**
 * `useGetApiToken` is a custom React hook that fetches an access token
 * silently and stores it in the Redux state using the `setApiToken` action.
 *
 */
const useSyncApiAccessToken = (): void => {
  const { isAuthenticated, isLoading } = useAuth0();
  const dispatch = useAppDispatch();

  const getToken = useCallback(async () => {
    const apiAccessToken = await security.getAccessTokenSilently()();
    if (apiAccessToken) {
      dispatch(setApiToken(apiAccessToken));
    }
  }, [dispatch]);

  // Get the access token on first page load
  useEffect(() => {
    // Make sure the user is authenticated before trying to get the token
    if (isAuthenticated && !isLoading) {
      getToken();
    }
  }, [isAuthenticated, isLoading, getToken]);
};

export default useSyncApiAccessToken;
